import React, { useCallback, useState, useRef, useEffect } from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FilterCrossIcon from "../../assets/icons/gray-cross-icon.svg";
import FilterIcon from "../../assets/icons/filtericon.svg";
import ProductBanner from "../../assets/images/product-banner.png";
import Pagination from "../../components/Pagination/Pagination";
import Loader from "../../components/Loader";
import Size from "./components/Size/Size";
import ColorBox from "./components/ColorsBox/ColorBox";
import Price from "./components/Price/Price";
import ProductGallary from "./components/ProductGallary/ProductGallary";
import HeaderSorting from "./components/HeaderSorting/HeaderSorting";
import SelectedFilter from "./components/HeaderSelectedFiter/SelectedFilter";

import {
  categoryList,
  designerList,
  discountList,
  genderList,
  shippingList,
  shopList,
} from "../../Data/data";
import FilterData from "./components/FilterData/FilterData";
import Clearall from "./components/ClearAllFilter/Clearall";
import { useDispatch, useSelector } from "react-redux";
import {
  FILTER_GET_COLOR,
  FILTER_GET_DESIGNER_SELLER,
  FILTER_GET_MASTER,
  FILTER_GET_SHIPPINGTIME,
  FILTER_GET_SIZE,
  PRODUCT_LIST,
} from "../../Redux/SagaAction/actions";
import ProductCardCM from "../../components/ProductCardCM/ProductCardCM";
import FilterCM from "../../components/FilterCM";
import SelectedFilterDataCM from "../../components/SelectedFilterDataCM";
import { decrypt, encrypt } from "../../Crypto/function";
import { inScListing } from "../../Redux/Slices/ProductSlice";

const ProductListing = () => {
  const [values, setValues] = useState([]);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [activeFilter, setIsActiveFilter] = useState(null);
  const [selectshopFilter, setSelectshopFilter] = useState([]);
  const [ischecked, setIschecked] = useState([]);
  const { productsList, ProductlistLoading, filter, totalCount } = useSelector(
    (state) => state.ProductSlice
  );
  const { addTCLoader } = useSelector((e) => e.AddToCartSlice);
  const {
    colorData,
    sizeData,
    shippingTimeData,
    designerSellerData,
    isLoadingColor,
    filterData,
    isLoadingSize,
    isLoadingSHTime,
    isLoadingDesigner,
  } = useSelector((e) => e.FiltergetSlice);
  const { specificAPIParams, isMainCLoading, isSubCLoading } = useSelector(
    (state) => state?.GetCategorySlice
  );

  const { checkedFilterCM } = useSelector((e) => e.FiltergetSlice);
  const minPrice = values[0];
  const maxPrice = values[1];

  const totalcount = totalCount;
  const [DataLimit, setDataLimit] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);
  const handleChangePage = useCallback(
    (currentPage) => {
      setCurrentPage(currentPage);
    },
    [currentPage]
  );
  const addFilterclass = () => {
    setIsActiveFilter(`filter-open`);
  };

  const [categorySA, setCategorySA] = useState([]);
  const [designerSA, setDesignerSA] = useState([]);
  const [colorSA, setColorSA] = useState([]);
  const [sizeSA, setSizeSA] = useState([]);
  const [shippingTimeSA, setShippingTimeSA] = useState([]);
  const [discountRLSA, setDiscountRLSA] = useState([]);

  useEffect(() => {
    if (checkedFilterCM?.category) {
      const CategoryArray = checkedFilterCM?.category.map((e) => e?.uniqId);
      setCategorySA(CategoryArray);
    }
    if (checkedFilterCM?.designer) {
      const DesignerArray = checkedFilterCM?.designer?.map((e) => e?.uniqId);
      setDesignerSA(DesignerArray);
    }
    if (checkedFilterCM?.color) {
      const ColorArray = checkedFilterCM?.color?.map((e) => e?.uniqId);
      setColorSA(ColorArray);
    }
    if (checkedFilterCM?.size) {
      const SizeArray = checkedFilterCM?.size?.map((e) => e?.uniqId);
      setSizeSA(SizeArray);
    }
    if (checkedFilterCM?.shippingTime) {
      const ShippingTimeArray = checkedFilterCM?.shippingTime?.map(
        (e) => e?.uniqId
      );
      setShippingTimeSA(ShippingTimeArray);
    }
    if (checkedFilterCM?.discountRangeList) {
      const DiscountRangeListArray = checkedFilterCM?.discountRangeList?.map(
        (e) => e?.uniqId
      );
      setDiscountRLSA(DiscountRangeListArray);
    }
  }, [
    checkedFilterCM?.category?.length,
    checkedFilterCM?.designer?.length,
    checkedFilterCM?.color?.length,
    checkedFilterCM?.size?.length,
    checkedFilterCM?.shippingTime?.length,
    checkedFilterCM?.discountRangeList?.length,
  ]);
  const { title } = useParams();
  console.log(categorySA,"categorySA",[decrypt(title)])

  useEffect(() => {
    if (specificAPIParams) {
      dispatch({
        type: PRODUCT_LIST,
        payload: {
          page: currentPage,
          limit: DataLimit,
          search: "",
          sortBy: "",
          sortKey: "",
          mainCategoryId: specificAPIParams,
          categoryId: (categorySA.length > 0 ? categorySA :  decrypt(title) ? [decrypt(title)] : []),
          sellerId: designerSA,
          sizeId: sizeSA,
          discount: discountRLSA,
          colorId: colorSA,
          minPrice,
          maxPrice,
          shippingTimeId: shippingTimeSA,
        },
        callback: () => {
          // dispatch(inScListing());
        },
      });
    }
  }, [
    currentPage,
    title,
    specificAPIParams,
    designerSA,
    categorySA,
    sizeSA,
    colorSA,
    shippingTimeSA,
    minPrice,
    maxPrice,
  ]);

  useEffect(() => {
    if (specificAPIParams) {
      dispatch({
        type: FILTER_GET_MASTER,
        payload: {
          mainCategoryId: specificAPIParams,
        },
        callback: (e) => {
          setValues([
            e?.priceRangeList?.[0]?.minPrice,
            e?.priceRangeList?.[0]?.maxPrice,
          ]);
        },
      });
    }
  }, [specificAPIParams]);

  // const handelInfiniteScroll = async() => {
  //   console.log("SCROLLHEIGHT" , document.documentElement.scrollHeight)
  //   console.log("INNERHEIGHT",window.innerHeight)
  //   console.log("SCROLLTOP",document.documentElement.scrollTop)

  //   try {

  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  // useEffect(()=> {
  //   window.addEventListener("scroll",handelInfiniteScroll)
  // },[])

  return (
    <>
      {(isMainCLoading ||
        isSubCLoading ||
        addTCLoader ||
        ProductlistLoading) && <Loader />}

      <div>
        <Container>
          {/* {ProductlistLoading && <Loader />} */}
          <Breadcrumb>
            <Breadcrumb.Item href="/swanee">Home</Breadcrumb.Item>
            {/* <Breadcrumb.Item href="/pernia">Listing</Breadcrumb.Item> */}
            <Breadcrumb.Item active>{state}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>
      <div className="product-listing-wrapper">
        <Container>
          <div className="filter-text" onClick={addFilterclass}>
            <img src={FilterIcon} alt="filter-icon" />
            Filter
          </div>
          <div
            className={
              activeFilter
                ? "product-listing-box filter-open"
                : "product-listing-box"
            }
          >
            <div className="filter-listing">
              <div
                className="filter-cross-icon"
                onClick={() => setIsActiveFilter(null)}
              >
                <img src={FilterCrossIcon} alt="FilterCrossIcon" />
              </div>
              <Clearall
                setSelectshopFilter={setSelectshopFilter}
                selectshopFilter={selectshopFilter}
                ischecked={ischecked}
                setIschecked={setIschecked}
              />

              <div className="filter-wrapper">
                <FilterCM
                  title="category"
                  data={filterData?.category}
                  name="categoryName"
                  count="categoryCount"
                />

                <FilterCM
                  title="designer"
                  data={filterData?.designer}
                  name="sellerName"
                  count="sellerCount"
                />
                <FilterCM title="size" data={filterData?.size} />
                <FilterCM title="color" data={filterData?.color} />
                {values !== undefined && values?.length > 0 && (
                  <Price
                    values={values}
                    setValues={(e) => setValues(e)}
                    data={filterData?.priceRangeList}
                    selectshopFilter={selectshopFilter}
                    setSelectshopFilter={setSelectshopFilter}
                    ischecked={ischecked}
                    filterTitle="price"
                    setIschecked={setIschecked}
                  />
                )}
                <FilterCM
                  title="discountRangeList"
                  data={filterData?.discountRangeList}
                />

                <FilterCM
                  title="shippingTime"
                  data={filterData?.shippingTime}
                  className="shippingTime-filter"
                />
              </div>
            </div>

            <div className="product-right-content">
              <div className="product-list">
                <div className="product-banner">
                  <img src={ProductBanner} alt="ProductBanner" />
                </div>

                <div className="product-header">
                  <div className="title">
                    {state}
                    <span>({productsList?.length} Products)</span>
                  </div>
                  <HeaderSorting />
                </div>

                {/* {filter && (
                  <SelectedFilter
                    setSelectshopFilter={setSelectshopFilter}
                    setIschecked={setIschecked}
                    selectshopFilter={selectshopFilter}
                  />
                )} */}
                <SelectedFilterDataCM setCurrentPage={setCurrentPage} />
                {/* <ProductCardCM/> */}

                <ProductGallary
                  setCurrentPage={setCurrentPage}
                  categoryId={encrypt(title)}
                  mainCategoryId={specificAPIParams}
                />
              </div>
              {productsList?.length > 0 && (
                <Pagination
                  total={Math.ceil(totalcount / DataLimit)}
                  current={currentPage}
                  onChangePage={handleChangePage}
                />
              )}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ProductListing;
